import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { JoonUIColor, Loader, UserRole } from "@joonapp/web-shared"
import { CellContext } from "@tanstack/react-table"
import { useId, useMemo } from "react"

import ClientTag from "../../../components/clientTag/ClientTag"
import {
  getTodoContent,
  useTodoActions,
} from "../../../components/todos/TodoItem"
import Tooltip from "../../../components/tooltip/Tooltip"
import { useCoachTodosQuery } from "../../../networking/coachTodos/queries"
import { CoachingGroup } from "../../../types"
import { CoachTodo, CoachTodoType } from "../../../types/coachTodos"
import { ClientTableData } from "../../../types/misc"

const TodosCell = (info: CellContext<ClientTableData, CoachingGroup>) => {
  const { data: todos, isLoading } = useCoachTodosQuery()

  const coachingGroup = info.row.original.coachingGroup
  const client = coachingGroup?.profiles.find((p) => p.role === UserRole.CLIENT)

  const filteredTodos = useMemo(() => {
    const clientTodos = todos?.filter(
      (todo) => todo.client.id === client?.user.id
    )
    // only show one todo of the QUEST_COMPLETION type, but every other todo should be shown
    const todosToShow =
      clientTodos?.filter(
        (todo) => todo.type !== CoachTodoType.QUEST_COMPLETION
      ) || []
    const questCompletedTodo = clientTodos?.find(
      (todo) => todo.type === CoachTodoType.QUEST_COMPLETION
    )
    if (questCompletedTodo) todosToShow.push(questCompletedTodo)
    return todosToShow
  }, [todos, client])

  if (!coachingGroup) return null

  if (isLoading)
    return <Loader size={12} thickness={2} color={JoonUIColor.icon.neutral} />

  return (
    <div className="flex flex-row gap-[2px]">
      <ClientTag coachingGroup={coachingGroup} />
      {filteredTodos?.map((todo) => (
        <TodoBadge key={todo.id} todo={todo} />
      ))}
    </div>
  )
}

export default TodosCell

const TodoBadge = ({ todo }: { todo: CoachTodo }) => {
  const tooltipId = useId()
  const { title, icon } = getTodoContent(todo.type)
  const todoAction = useTodoActions(todo)

  return (
    <>
      <button onClick={todoAction}>
        <div
          className="flex p-1 rounded-md bg-neutral-100"
          data-tooltip-id={tooltipId}
        >
          <FontAwesomeIcon icon={icon} color={JoonUIColor.semantic.warning} />
        </div>
      </button>
      <Tooltip id={tooltipId}>
        <div>{title}</div>
      </Tooltip>
    </>
  )
}
